import { nanoId } from '@/helpers'


/**
 * Set payment data with Detail Lines
 * @param {Array} paymentDataList - Array of Detail Lines.
 */
export const set = ({ commit, dispatch }, paymentDataList) => {
  return new Promise((resolve, reject) => {
    if (!Array.isArray(paymentDataList)) reject(new Error(`${paymentDataList} must be an array`))
    Promise.all(
      paymentDataList.map(paymentData => {
        dispatch('insertDetail', paymentData)
      })
    ).then(() => {
      resolve()
    }, (err) => {
      reject(err)
    })
  })
}

export const empty = ({ dispatch, commit }) => {
  return new Promise((resolve) => {
    dispatch('emptyDetail').then(() => {
      commit('SET_LIST', [])
      resolve()
    })
  })
}

export const emptyDetail = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_SELECTED_KEY', undefined)
    commit('SET_PAYMENT_DATE', undefined)
    commit('SET_AMOUNT', undefined)
    commit('SET_PAYMENT_METHOD', undefined)
    commit('SET_IBAN_DEBITED', undefined)
    commit('SET_IBAN_CREDITED', undefined)
    resolve()
  })
}

/**
 * Upsert payment data with Detail Line
 * @param {Object} paymentData - Detail Line
 */
export const upsertDetail = ({ dispatch }, paymentData) => {
  if (paymentData.key) {
    return dispatch('updateDetail', paymentData)
  } else {
    return dispatch('insertDetail', paymentData)
  }
}

/**
 * Insert payment data with Detail Line
 * @param {Object} paymentData - Detail Line
 */
export const insertDetail = ({ state }, paymentData) => {
  let payment = {
    key: nanoId(8),
    ...paymentData
  }
  state.list.push(payment)
  return Promise.resolve()
}

/**
 * Update payment data with Detail Line
 * @param {Object} paymentData - Detail Line
 */
export const updateDetail = ({ state }, paymentData) => {
  let paymentKey = paymentData.key
  let paymentInList = state.list.find(payment => payment.key === paymentKey)
  Object.assign(paymentInList, paymentData)
  return Promise.resolve()
}
